/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import(/* webpackChunkName: "pages" */ './layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Home
        // =============================================================================
        {
          path: '/',
          name: 'home',
          //component: () => import('./views/operation/BalancoEnergetico.vue'),
          component: () => import('./views/Home.vue'),
          meta: {
            pageTitle: 'Home',
            roles: ['BALANCE_VIEW']
          }
        },
        // =============================================================================
        // Empresas
        // =============================================================================
        {
          path: '/empresas',
          name: 'Empresas',
          component: () => import(/* webpackChunkName: "empresa" */ './views/balance/EmpresaList.vue'),
          meta: {
            pageTitle: 'Empresa',
            roles: ['COMPANY_VIEW']
          }
        },
        {
          path: '/empresa-add',
          name: 'Adicionar Empresa',
          component: () => import(/* webpackChunkName: "empresa" */ './views/balance/EmpresaAdd.vue'),
          meta: {
            pageTitle: 'Adicionar Empresa',
            roles: ['COMPANY_ADD']
          }
        },
        {
          path: '/balanco/:guid',
          name: 'Empresa',
          component: () => import(/* webpackChunkName: "empresa" */ './views/balance/EmpresaView.vue'),
          props: (route) => { return { guid: route.params.guid } },
          meta: {
            pageTitle: 'Empresas',
            roles: ['COMPANY_VIEW']
          }
        },
        // =============================================================================
        // Relatório de Crédito tenantType:'FINANCE'
        // =============================================================================
        {
          path: '/relatorio-credito',
          name: 'Relatório',
          component: () => import(/* webpackChunkName: "empresa" */ './views/finance/ReportList.vue'),
          meta: {
            pageTitle: 'Relatório',
            roles: ['COMPANY_VIEW']
          }
        },
        // =============================================================================
        // Portfolios
        // =============================================================================
        {
          path: '/portfolio',
          name: 'Portfolios',
          component: () => import(/* webpackChunkName: "porfolio" */ './views/portfolio/PortfolioList.vue'),
          meta: {
            pageTitle: 'Portfolios',
            roles: ['PORTFOLIO_VIEW']
          }
        },
        // =============================================================================
        // Limite e Exposição
        // =============================================================================
        {
          path: '/limit',
          name: 'Limite e Exposição',
          component: () => import(/* webpackChunkName: "limit" */ './views/limit/LimitList'),
          meta: {
            pageTitle: 'Limite e Exposição',
            roles: ['LIMIT_VIEW']
          }
        },
        // =============================================================================
        // Operação
        // =============================================================================
        {
          path: '/operation',
          name: 'Balanços Energético',
          component: () => import(/* webpackChunkName: "operation" */ './views/operation/BalancoEnergetico.vue'),
          meta: {
            pageTitle: 'Balanços',
            roles: ['OPERATION_VIEW']
          }
        },
        {
          path: '/operation/:guid',
          name: 'Balanço Energético',
          component: () => import(/* webpackChunkName: "operation" */ './views/operation/BalancoEnergeticoView.vue'),
          props: (route) => { return { guid: route.params.guid } },
          meta: {
            pageTitle: 'Balanço Energético',
            roles: ['OPERATION_VIEW']
          }
        },
        {
          path: '/operation/analytics',
          name: 'Análise do Balanço Energético',
          component: () => import(/* webpackChunkName: "operation" */ './views/operation/BalancoEnergeticoStats.vue'),
          meta: {
            pageTitle: 'Análise do Balanço Energético',
            roles: ['OPERATION_VIEW']
          }
        },
        // =============================================================================
        // Propostas
        // =============================================================================
        {
          path: '/propose',
          name: 'Propostas',
          component: () => import(/* webpackChunkName: "propose" */ './views/propose/PropostaList.vue'),
          meta: {
            pageTitle: 'Listar Propostas',
            roles: ['PROPOSE_VIEW']
          }
        },
        {
          path: '/propose/:guid',
          name: 'Proposta',
          component: () => import(/* webpackChunkName: "propose" */ './views/propose/PropostaView.vue'),
          props: (route) => { return { guid: route.params.guid } },
          meta: {
            pageTitle: '',
            roles: ['PROPOSE_VIEW']
          }
        },
        {
          path: '/propose-add',
          name: 'Cadastrar uma nova proposta',
          component: () => import(/* webpackChunkName: "propose" */ './views/propose/PropostaAdd.vue'),
          meta: {
            pageTitle: 'Cadastrar Nova Proposta',
            roles: ['PROPOSE_ADD']
          }
        },
        // =============================================================================
        // Garantias
        // =============================================================================
        {
          path: '/guarantee',
          name: 'Controle de Garantias',
          component: () => import(/* webpackChunkName: "guarantee" */ './views/guarantee/GarantiaList.vue'),
          meta: {
            pageTitle: 'Controle de Garantias',
            roles: ['GUARANTEE_VIEW']
          }
        },
        {
          path: '/guarantee/stats',
          name: 'Quadro de Análise',
          component: () => import(/* webpackChunkName: "guarantee" */  './views/guarantee/GarantiaStats.vue'),
          meta: {
            pageTile: 'Quadro de Análise',
            roles: ['GUARANTEE_VIEW']
          }
        },
        {
          path: '/guarantee/upload',
          name: 'Upload de Contratos',
          component: () => import(/* webpackChunkName: "guarantee" */ './views/guarantee/GuaranteeAdd'),
          props: (route) => { return { guid: route.params.guid } },
          meta: {
            pageTitle: 'Upload de Contratos',
            roles: ['GUARANTEE_ADD']
          }
        },
        {
          path: '/guarantee/:guid',
          name: 'Contratos',
          component: () => import(/* webpackChunkName: "guarantee" */ './views/guarantee/GarantiaView.vue'),
          props: (route) => { return { guid: route.params.guid } },
          meta: {
            pageTitle: 'Contratos',
            roles: ['GUARANTEE_VIEW']
          }
        },
        // =============================================================================
        // Robôs
        // =============================================================================
        {
          path: '/robots',
          name: 'Robôs',
          component: () => import(/* webpackChunkName: "robots" */ './views/robot/Robots.vue'),
          meta: {
            pageTitle: 'Robôs',
            roles: ['ROBOT_VIEW']
          }
        },
        // =============================================================================
        // Dados Históricos
        // =============================================================================
        {
          path: '/ccee/comercializadoras',
          name: 'Dados Comercializadoras',
          component: () => import(/* webpackChunkName: "ccee" */ './views/ccee/ComercializadoraList.vue'),
          meta: {
            pageTitle: 'Dados Históricos',
            roles: ['TRADER_VIEW']
          }
        },
        {
          path: '/ccee/geradoras',
          name: 'Dados Geradoras',
          component: () => import(/* webpackChunkName: "ccee" */ './views/ccee/GeradoraList.vue'),
          meta: {
            pageTitle: 'Dados Históricos',
            roles: ['GENERATOR_VIEW']
          }
        },
        // =============================================================================
        // Profile
        // =============================================================================
        {
          path: '/profile',
          name: 'Profile',
          component: () => import(/* webpackChunkName: "ccee" */ './views/pages/Profile'),
          meta: {
            pageTitle: 'Profile',
            roles: ['OPERATION_VIEW']
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/new-password/:guid',
          name: 'page-new-password',
          component: () => import('@/views/pages/NewPassword.vue'),
          props: (route) => { return { guid: route.params.guid } },
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'page-login' && to.name !== 'page-new-password' && !isValid(to)) next({ name: 'page-login' })
  else next()
})

function isValid (to) {
  if (localStorage.currentUser == null) {
    return false
  }
  if (localStorage.token == null) {
    return false
  }
  const currentUser = JSON.parse(localStorage.currentUser)
  if (to.meta.roles && currentUser.roles) {
    for (const role of currentUser.roles) {
      if (to.meta.roles.includes(role)) {
        // user has valid role
        return true
      }
    }
  } else {
    // not authenticated user
    return false
  }
  return false
}


export default router
